<classic-report [report]="this.reportVariant" [reportName]="this.name"
  [defaultDisplayColumns]="this.defaultDisplayColumns" [dateFilterTypes]="this.dateFilters"
  [activeLearnerToggle]="false" [defaultColumnOrder]="this.defaultColumnOrder" [reportRefreshed]="true"
  [groupByColumns]="this.groupByColumns">
</classic-report>